<template>
  <div id="app">
    <keep-alive>
    <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
// import Layout from '@/layout/index.vue';
export default {
  name: "App",
  //===下面是解决刷新页面丢失vuex数据
  created() {
    //在页面刷新时将vuex里的信息保存到localStorage里
    this.$store.commit("setAccountInfo", this.$store.state.token);
    // window.addEventListener('unload', () => {
    //   this.$store.commit('setToken',this.$store.state.token)
    //   // localStorage.setItem('token', JSON.stringify(this.$store.state.token));
    // });
  },
  mounted: function () {
    //此方法刷新页面时也会执行
    // window.addEventListener("beforeunload", () => {
    //   localStorage.removeItem("token");
    // });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
